import axios from 'axios';
import { Auth } from '../../common/auth';
import { memoizedRefreshToken } from './refreshToken';

const apiURL = process.env.REACT_APP_API_BASE_URL;

axios.defaults.baseURL = apiURL;

axios.interceptors.request.use(
    async (config) => {
        const accessToken = Auth.getAccessToken();

        if (accessToken) {
            config.headers = {
                ...config.headers,
                Authorization: `Bearer ${accessToken}`
            };
        }

        return config;
    },
    (error) => Promise.reject(error)
);

axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const config = error?.config;

        if (error?.response?.status === 401 && !config?.sent) {
            config.sent = true;

            const result = await memoizedRefreshToken();

            if (result.success) {
                config.headers = {
                    ...config.headers,
                    Authorization: `Bearer ${result.token}`
                };
            }

            return axios(config);
        }
        return Promise.reject(error);
    }
);

export const axiosPrivate = axios;
